import styled from "styled-components";
import ProductCardView from "./ProductCardView";
import TablePagination from "@mui/material/TablePagination";
import GridViewIcon from "@mui/icons-material/GridViewSharp";
import TableRowsSharpIcon from "@mui/icons-material/TableRowsSharp";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as productActions from "../../redux/actions/productActions";
import { colors } from "../../res/values/values";
import useWindowWidthAndHeight from "../../utilities/hooks/useWindowWidthAndHeight";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from "react-router-dom";
//#region Styles
const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0rem 0.3rem;
  align-items: center;
  min-height: 40vw;
  
`;
const ProductList = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
  }
`;
const EmptyProductList = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${colors.primaryColor};
`;
const ListType = styled.div`
  display: flex;
  flex-direction: center;
  align-items: center;
  border: 1.5px solid lightgray;
  border-color: ${(props) => props.selected && colors.primaryColor};
  margin: 5px;
`;
const TablePaginationContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;


//#endregion

function Products(props) {
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(parseInt(props.page));

  const [rowsPerPage, setRowsPerPage] = useState(parseInt(props.rowsPerPage));
  const [changePageStatus, setChangePageStatus] = useState(false);
  const [listType, setListType] = useState(props.listType);
  const { width } = useWindowWidthAndHeight();
  const navigate = useNavigate();
  useEffect(() => {

    const renderPage = async () => {
      
     // if (changePageStatus) setChangePageStatus(false);
     // else {
     //   setPage(0);
     //   setRowsPerPage(10);
     // }
      await props.actions.getProducts(
        props.categoryid,
        props.productid,
        props.filter,
        page,
        rowsPerPage,
        props.currentUser,
        props.brand,
        props.country
      );

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      setLoading(false);
    };
    //setLoading(true)
    renderPage();
    return () => {
      //setLoading(true);
      //props.actions.clearProducts();
    };
  }, [
    props.filter,
    props.productid,
    props.categoryid,
    props.brand,
    props.country,
    props.page,
    props.rowsPerPage,
    props.listType
  ]);

  const handleChangePage = (event, newPage) => {
    if(props.categoryid || props.productid ){
      if(props.productid){
        const currentSubCategory =  props.categories.find(x => x.code === props.productid)
        navigate(`/product-categories/${currentSubCategory.seodescription}?${props.filter ? `&filter=${props.filter}` : ''}${props.brand ? `&brand=${props.brand}` : ''}${props.country ? `&country=${props.country}` : ''}&page=${newPage}&rowsPerPage=${rowsPerPage}&listType=${listType}`);
      }else{
        const currentParentCategory =  props.categories.find(x => x.code === props.categoryid)
        navigate(`/product-categories/${currentParentCategory.seodescription}?${props.filter ? `&filter=${props.filter}` : ''}${props.brand ? `&brand=${props.brand}` : ''}${props.country ? `&country=${props.country}` : ''}&page=${newPage}&rowsPerPage=${rowsPerPage}&listType=${listType}`);
      }
    }else{
      navigate(
      `/search?${props.filter ? `&filter=${props.filter}` : ""}${
        props.categoryid ? `&categoryid=${props.categoryid}` : ""
      }${props.brand ? `&brand=${props.brand}` : ""}${
        props.country ? `&country=${props.country}` : ""
      }&page=${newPage}&rowsPerPage=${rowsPerPage}&listType=${listType}`)
    }
    
    //setChangePageStatus(true);
    //setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    if(props.categoryid || props.productid ){
      if(props.productid){
        const currentSubCategory =  props.categories.find(x => x.code === props.productid)
        navigate(`/product-categories/${currentSubCategory.seodescription}?${props.filter ? `&filter=${props.filter}` : ''}${props.brand ? `&brand=${props.brand}` : ''}${props.country ? `&country=${props.country}` : ''}&page=${page}&rowsPerPage=${parseInt(event.target.value, 10)}&listType=${listType}`);
      }else{
        const currentParentCategory =  props.categories.find(x => x.code === props.categoryid)
        navigate(`/product-categories/${currentParentCategory.seodescription}?${props.filter ? `&filter=${props.filter}` : ''}${props.brand ? `&brand=${props.brand}` : ''}${props.country ? `&country=${props.country}` : ''}&page=${page}&rowsPerPage=${parseInt(event.target.value, 10)}&listType=${listType}`);
      }
    }else{
      navigate(
        `/search?${props.filter ? `&filter=${props.filter}` : ""}${
          props.categoryid ? `&categoryid=${props.categoryid}` : ""
        }${props.brand ? `&brand=${props.brand}` : ""}${
          props.country ? `&country=${props.country}` : ""
        }&page=${page}&rowsPerPage=${parseInt(event.target.value, 10)}&listType=${listType}`)
    }
  };
  const handleChangeListType = (type) => {
    if(props.categoryid || props.productid ){
      if(props.productid){
        const currentSubCategory =  props.categories.find(x => x.code === props.productid)
        navigate(`/product-categories/${currentSubCategory.seodescription}?${props.filter ? `&filter=${props.filter}` : ''}${props.brand ? `&brand=${props.brand}` : ''}${props.country ? `&country=${props.country}` : ''}&page=${page}&rowsPerPage=${rowsPerPage}&listType=${type}`);
      }else{
        const currentParentCategory =  props.categories.find(x => x.code === props.categoryid)
        navigate(`/product-categories/${currentParentCategory.seodescription}?${props.filter ? `&filter=${props.filter}` : ''}${props.brand ? `&brand=${props.brand}` : ''}${props.country ? `&country=${props.country}` : ''}&page=${page}&rowsPerPage=${rowsPerPage}&listType=${type}`);
      }
    }else{
      navigate(
      `/search?${props.filter ? `&filter=${props.filter}` : ""}${
        props.categoryid ? `&categoryid=${props.categoryid}` : ""
      }${props.brand ? `&brand=${props.brand}` : ""}${
        props.country ? `&country=${props.country}` : ""
      }&page=${page}&rowsPerPage=${rowsPerPage}&listType=${type}`)
    }
  };
  return (
    <Container>
      {loading ? (
        <Container>
          <CircularProgress
                  size={40}
                  thickness={4}
            
                />
        </Container>
      ) : props.products.length > 0 ? (
        <Container>
          <TablePaginationContent>
            <ListType
              selected={listType === "Grid"}
              onClick={() => handleChangeListType("Grid")}
            >
              <GridViewIcon sx={{ color: colors.darkcolor }} />
            </ListType>
            <ListType
              selected={listType === "List"}
              onClick={() => handleChangeListType("List")}
            >
              <TableRowsSharpIcon sx={{ color: colors.darkcolor }} />
            </ListType>

            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={props.productCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={"Rows:"}
            />
          </TablePaginationContent>
          <ProductList>
            {props.products.map((p) => {
              return (
                <ProductCardView
                  key={p.itemno}
                  product={p}
                  viewType={listType}
                  page={page}
                  rowsPerPage={rowsPerPage}
                />
              );
              /*
              if(listType==='Grid')
                return( <ProductCard key={p.itemno} product={p} />);
              else
                return( <ProductCardForListView key={p.itemno} product={p} />);
              */
            })}
          </ProductList>
          <TablePaginationContent>
            <ListType
              selected={listType === "Grid"}
              onClick={() => handleChangeListType("Grid")}
            >
              <GridViewIcon sx={{ color: colors.darkcolor }} />
            </ListType>
            <ListType
              selected={listType === "List"}
              onClick={() => handleChangeListType("List")}
            >
              <TableRowsSharpIcon sx={{ color: colors.darkcolor }} />
            </ListType>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={props.productCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TablePaginationContent>
        </Container>
      ) : (
        <EmptyProductList>
          Sorry, there were no results matching your search or filter.
        </EmptyProductList>
      )}
    </Container>
  );
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      getProducts: bindActionCreators(productActions.getProducts, dispatch),
      getFilterProducts: bindActionCreators(
        productActions.getFilterProducts,
        dispatch
      ),
      clearProducts: bindActionCreators(
        productActions.clearProductsSuccess,
        dispatch
      ),
    },
  };
}

function mapStateToProps(state) {
  return {
    products: state.productListReducer,
    search: state.changeSearchReducer,
    productCount: state.productCountReducer,
    currentUser: state.currentUserReducer,
    categories: state.categoryListReducer,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Products);
